import { EnvironmentConfig } from 'types';

export const OAUTH_POSTMESSAGE_SOURCE = 'oauth-popup';

export const GOOGLE_CLIENT_ID: EnvironmentConfig = {
  prod: '386310960703-cq80k0cu385e4samlojsv20d076rr5oi.apps.googleusercontent.com',
};

export const GOOGLE_ONE_TAP_SCRIPT = 'https://accounts.google.com/gsi/client';

export const APPLE_SCRIPT_SRC =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

export const APPLE_AUTH_CLIENT_ID: EnvironmentConfig = {
  dev: 'app.headliner.dev.signin',
  prod: 'app.headliner.headliner.signin',
};

export const FACEBOOK_SCRIPT_SRC = 'https://connect.facebook.net/en_US/sdk.js';

export const FACEBOOK_APP_ID: EnvironmentConfig = {
  dev: '577460502745594',
  prod: '1982886521833119',
};
